"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDeleteDisciplinePayloadToFormDataHandler = addDeleteDisciplinePayloadToFormDataHandler;
function addDeleteDisciplinePayloadToFormDataHandler(data) {
    return {
        SN: data.form.SN,
        PT: data.form.PT,
        OT: data.form.OT,
        SLP: data.form.SLP,
        MSW: data.form.MSW,
        HHA: data.form.HHA,
        frequencyForAide: data.form.frequencyForAide,
        RD: data.form.RD,
        notes: data.form.comments || "",
    };
}
